import client from './client';

export const labelsApi = {
  async list() {
    const { data } = await client.get('/api/labels');
    return data;
  },

  async create(label) {
    const { data } = await client.post('/api/labels', label);
    return data;
  },

  async update(id, updates) {
    const { data } = await client.patch(`/api/labels/${id}`, updates);
    return data;
  },

  async delete(id) {
    const { data } = await client.delete(`/api/labels/${id}`);
    return data;
  },
};
